/* unplugin-vue-components disabled */import { render } from "./CartIconDisplayer.vue?vue&type=template&id=161379ac"
import script from "./CartIconDisplayer.vue?vue&type=script&lang=js"
export * from "./CartIconDisplayer.vue?vue&type=script&lang=js"

import "./CartIconDisplayer.vue?vue&type=style&index=0&id=161379ac&lang=scss"
script.render = render

export default script